import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import Router from 'next/router';
import Button from './button/Button';
import PriceTag from './PriceTag';
import { H3 } from './typography';

const Card = styled.div`
  padding: ${({ theme }) => theme.space.xsmall};
  background: ${({ popular, theme }) =>
    popular ? theme.palette.BEIGE_DARK : theme.palette.BEIGE};
  color: ${({ theme }) => theme.palette.WHITE};
  min-width: 260px;
  min-height: 350px;
  border-radius: ${({ theme }) => theme.space.medium};
  display: flex;
  align-items: center;
  flex-direction: column;
  box-shadow: ${({ popular, theme }) =>
    `${theme.boxShadowMedium} ${
      popular ? theme.palette.BEIGE : theme.palette.BEIGE_DARK
    }`};
  margin: ${({ theme }) => theme.space.small};
  @media (max-width: ${({ theme }) => theme.breakPoints.tablet}) {
    margin: ${({ theme }) =>
      `${theme.space.medium} ${theme.space.xxlarge} ${theme.space.small}`};
    margin-top: ${({ theme }) => theme.space.medium};
  }
`;

const CardTitle = styled(H3)`
  font-size: 14px;
  margin: ${({ theme }) => theme.space.xsmall};
  color: ${({ theme }) => theme.palette.GREEN};
`;

const Infobox = styled.div`
  text-align: center;
  margin: 15px auto;
  margin-bottom: auto;
`;

const InfoItem = styled.span`
  font-size: 14px;
  color: ${({ theme, popular }) => theme.palette.WHITE};
`;

const StyledButton = styled(Button)`
  margin-bottom: 20px;
`;

const handleAction = (action) => {
  const { value, type } = action;
  switch (type) {
    case 'url': {
      Router.push(value);
      return;
    }
    case 'email': {
      window.location = 'mailto:' + value;
      return;
    }
    default:
      return;
  }
};

const PricingCard = ({
  item: { title, price, description, buttonText, currency, action, popular },
  buttonColor,
  ...rest
}) => (
  <Card popular={popular} {...rest}>
    <CardTitle>{title}</CardTitle>
    <PriceTag price={price} currency={currency} />
    <Infobox>
      {description?.map((item) => (
        <motion.div
          key={item}
          whileHover={{ scale: 1.1, originX: 0, color: 'black' }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <InfoItem popular={popular}>{item}</InfoItem>
        </motion.div>
      ))}
    </Infobox>
    <StyledButton
      variant="outlined"
      {...(buttonColor ? { color: buttonColor } : {})}
      onClick={() => handleAction(action)}
    >
      {buttonText}
    </StyledButton>
  </Card>
);

export default PricingCard;
